import { GatsbyBrowser } from "gatsby";
import shouldUpdateScroll from "./shouldUpdateScroll";
import wrapPage from "./wrap-page";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = wrapPage;

export { shouldUpdateScroll };
